import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import { FormInput } from "../../components/FormInput";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { checkDpSuccess, getCompanyType, getFormErrorMessage, getMaskedString } from "../../utility/service/tool-service";
import { MessageContext,handleSuccessMessage } from "../../store/messageStore";
import { queryIndustryList } from "../../utility/service/register-service";
import { SystemLoading,checkLoading } from "../../store/loadingStore";
import { createInviteRecords, getInviteRecordsInfo, updateInviteRecords } from "../../utility/service/invite-service";
import { updateAuditEyesEvent } from "../../utility/service/audilog-service";
import { useFuncId } from "../../router/menuRouterMapper";

export default function InviteRecord_Detail(){

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { itemObj,setItemObj,action,setAction, currentStatus, setCurrentStatus } = useOutletContext();
    const [detailObj,setDetailObj] = useState({});
    const [, dispatch] = useContext(MessageContext); //訊息視窗  
    const [,loading] = useContext(SystemLoading);
    const [editAction,setEditAction] = useState('detail');//設定目前的動作
    const [ industryList,setIndustryList] = useState([]);
    const [maskView,setMaskView]=useState(false)
    const chsFuncId = useFuncId();

    const useTypeList = [
        {
            label:t('company.a'),value:"A"
        },
        {
            label:t('company.b'),value:"B"
        }
    ]
 
    const {
        register,
        handleSubmit,
        watch,
        clearErrors,
        getValues,
        setValue,
        resetField,
        reset: resetForm,
        control,
        trigger,
        reset,
        formState: { errors, isValid, isDirty }
      } = useForm({
        defaultValues: {
            name:'',
            useTypes: []
        },
        //錯誤驗證時機
        mode: "all"
      });

    const btnBackTo = ()=>{
        navigate(`/management/inviteRecord`);
    }

    useEffect(()=>{
        if((action)!==''){
            axios_queryIndustryList();
            setDetailObj(itemObj);
            setValue("industryCode",itemObj?.industryCode);
            setValue("type",itemObj?.type);
        }else{
            btnBackTo();
        }
    },[action])

    const axios_queryIndustryList = ()=>{ //取得行業別下拉清單
        queryIndustryList()
            .then((res)=>{
                if(checkDpSuccess(res)){
                    let data = res.data.RespBody?.industryList;
                    setIndustryList(data);
                }
            })
    }

    const axios_updateAuditEyesEvent = ()=>{
        updateAuditEyesEvent({
            functionId:chsFuncId,
            eventType:"V"
        })
        .then((res)=>{
            if(checkDpSuccess(res)){
    
            }
        })
    }


    return (
    <>
    {/* 返回上頁 */}
    <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
            <Button rounded text onClick={() => { btnBackTo(); }}>
            <FontAwesomeIcon icon="fa-solid fa-arrow-left-long" />
            {t('button.return_to_list')}
            </Button>
        </div>
    </div>
    <div className="" style={{ top: "28px" }}>
        <Button
        type="button"
        icon={`pi ${maskView ? "pi-eye" : "pi-eye-slash"}`}
        severity="secondary"
        onClick={() => {
            setMaskView(prev => {
                if(!prev){
                    axios_updateAuditEyesEvent();
                }
                return !prev;
                });
        }}
        />
    </div>
    <div className="p-card">
        <div className="p-card-body">
            <form>
            <div className="grid">
                {/*統一編號*/}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("company_num")}
                    </label>
                    <span>{detailObj?.taxIdNum}</span>
                </div>
                {/*組織名稱*/}
                <div className='col-12 lg:col-3'>
                    <label
                        className="form-label">
                        {t("org_name")}
                    </label>
                    <span>{detailObj?.companyName}</span>
                </div>
                {/* 行業代碼 */}
                <div className='col-12 lg:col-3'>
                <label
                htmlFor="industryCode"
                className={`form-label ${editAction==='update' || editAction==='create'?'required':''}`}>
                {t('industry')}
            </label>
                <Controller
                    name="industryCode"
                    control={control}
                    rules={{required: { value: true, message: t('validation.required') }}}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={true}
                            filter
                            optionLabel="industryName"
                            optionValue="industryCode"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="industryCode"
                            control={control}
                            options={industryList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
              {getFormErrorMessage(errors, "industryCode")}
                </div>
                {/* 身分別 */}
                <div className='col-12 lg:col-3'>
                <label
                htmlFor="type"
                className={`form-label ${editAction==='update' || editAction==='create'?'required':''}`}>
                {t('useType')}
            </label>
                <Controller
                    name="type"
                    control={control}
                    rules={{required: { value: true, message: t('validation.required') }}}
                    render={({ field, fieldState }) => (
                        <Dropdown
                            disabled={true}
                            filter
                            optionLabel="label"
                            optionValue="value"
                            value={field.value}
                            virtualScrollerOptions={{ itemSize: 40 }}
                            defaultValue={""}
                            placeholder={t("plz_chs")}
                            name="type"
                            control={control}
                            options={useTypeList}
                            className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                            onChange={(event) => {
                                field.onChange(event.value);
                            }}
                        />
                    )}
                />
              {getFormErrorMessage(errors, "industryCode")}
                </div>

            </div>
            <div className="grid my-1">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("companyLeader")}
                    </label>
                    <span>{!maskView?getMaskedString("name",detailObj?.leader):detailObj?.leader}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {`${t('company.a')} ${t('companyEamil')}`}
                    </label>
                    <span>{!maskView?getMaskedString("email",detailObj?.email):detailObj?.email}</span>
                </div>
                <div className="col-12 lg:col-6">
                    <label
                        className="form-label">
                        {t('address')}
                    </label>
                    <span>{!maskView?getMaskedString("address",detailObj?.address):detailObj?.address}</span>
                </div>
            </div>           
            <div className="grid my-1">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t('user_name')}
                    </label>
                    <span>{!maskView?getMaskedString("username",detailObj?.userName):detailObj?.userName}</span>
                </div>
                {/* <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t('tel')}
                    </label>
                    <span>{detailObj?.phone}</span>
                </div>   */}
                <div className="col-12 lg:col-6">
                    <label
                        className="form-label">
                        {t('user_email')}
                    </label>
                    <span>{!maskView?getMaskedString("email",detailObj?.userEmail):detailObj?.userEmail}</span>
                </div>    
            </div>
            <div className="grid">
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("invitationCode")}
                    </label>
                    <span>{detailObj?.inviteCode}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("inviValidDate")}
                    </label>
                    <span>{detailObj?.inviteEndDate}</span>
                        
                </div>

            </div>
            <div className="grid">
                <div className="col-12 lg:col-6">

                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_user")}
                    </label>
                    <span>{detailObj?.updateUser}</span>
                </div>
                <div className="col-12 lg:col-3">
                    <label
                        className="form-label">
                        {t("update_date")}
                    </label>
                    <span>{detailObj?.updateDateTime}</span>
                </div>

            </div>
            <div className="col-12 gap-2 flex-all-center">
                <Button outlined size="small" type="button" label={t("button.cancel")} onClick={(e) => {
                        btnBackTo();
                }} />
            </div>
            </form>
          
        </div>
    </div>
    </>
    )
}